import { REGISTER, REGISTER_CLEAR } from './types';
const initialState = {
    patientId: '',
    country: '',
    language: 'en-US',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    email: '',
    password: '',
    confirmPassword: '',
    guardianFirstName: '',
    guardianLastName: '',
    gender: '',
    birthCountry: '',
    birthZipCode: '',
    consents: [
        {
            id: 'touLibre',
            action: 'decline',
        },
        {
            id: 'pp',
            action: 'decline',
        },
    ],
    isMinor: false,
    currentStep: 0,
    countryResidenceChecked: false,
};
export const registerReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER:
            return {
                ...state,
                ...action.register,
            };
        case REGISTER_CLEAR:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
